<template>
  <div id="login">
    <section>
      <div class="col1">
        <h1>RKO</h1>
        <span v-if="showWelcomeMessage">
          <p>
            A platform to create, manage, and integrate OKRs into existing
            organization workflow.
          </p>
          <p>
            Objectives and Key Results (OKRs) provide a framework for defining
            and managing objectives
          </p>
        </span>
        <span v-else>
          <p>
            {{ name }},
            <br />
            Thank you for registering. A confirmation email has been sent to
            {{ email }}. Please click the link in that message to confirm this
            email address. Once confirmed you can login and manage your
            objectives.
          </p>
          <ul>
            <li>
              <a @click="resendAuth">Resend Confirmation Email</a>
            </li>
          </ul>
        </span>
        <p>
          This application is still under development. Email the
          <a href="mailto:productmanagement@bossanovasoftserve.com"
            >Product Team</a
          >
          if you are interested in learning more about the current state of the
          platform
        </p>
      </div>
      <div id="firebaseui-auth-container" class="col2"></div>
    </section>
  </div>
</template>

<script>
import Firebase from "firebase/app";
import "firebase/auth";
import * as FirebaseUI from "firebaseui";

export default {
  data() {
    return {
      name: "",
      email: "",
      showWelcomeMessage: true
    };
  },
  created() {
    if (this.$store.getters.getUser) {
      this.name = this.$store.getters.getUser.displayName;
      this.email = this.$store.getters.getUser.email;
      this.showWelcomeMessage = false;
    }
  },
  mounted() {
    const router = this.$router;
    var uiConfig = {
      signInSuccessUrl: "/dashboard",
      signInOptions: [Firebase.auth.EmailAuthProvider.PROVIDER_ID],
      credentialHelper: FirebaseUI.auth.CredentialHelper.NONE,
      callbacks: {
        // eslint-disable-next-line no-unused-vars
        signInSuccessWithAuthResult: function(authResult, redirectUrl) {
          if (
            authResult.additionalUserInfo.providerId === "password" &&
            authResult.additionalUserInfo.isNewUser
          ) {
            authResult.user.sendEmailVerification().catch(err => {
              // eslint-disable-next-line no-console
              console.error(err);
            });
            router.go();
            return false;
          } else if (authResult.user && !authResult.user.emailVerified) {
            router.go();
            return false;
          }
          return true;
        }
      }
    };
    var fbauthui = new FirebaseUI.auth.AuthUI(Firebase.auth());
    fbauthui.start("#firebaseui-auth-container", uiConfig);
  },
  methods: {
    resendAuth() {
      this.$store.getters.getUser.sendEmailVerification().catch(err => {
        // eslint-disable-next-line no-console
        console.error(err);
      });
    }
  }
};
</script>

<style src="firebaseui/dist/firebaseui.css"></style>
